export default class TipoEnvioEstadoCuentaModel {
  image: string;
  title: string;
  cardTitle: string;
  description: string;
  terms: string;
}